import { useEffect, useReducer } from 'react'
import api, { IWorkplaceGroupDetails } from '@api'
import { Toaster } from '@ui'
import { ApolloError } from 'apollo-boost'
import { useShouldReload } from '@hooks/reloadContext'

enum Actions {
  DETAILS,
}

interface Details {
  type: Actions.DETAILS
  item: IWorkplaceGroupDetails
}

type RootAction = Details

interface IState {
  item: IWorkplaceGroupDetails | null
  isLoading: boolean
}

export interface UseWorkplaceGroupHook extends IState {
  id: string
}

function reducer(state: IState, action: RootAction): IState {
  switch (action.type) {
    case Actions.DETAILS:
      return {
        ...state,
        isLoading: false,
        item: action.item,
      }

    default:
      return state
  }
}

export default function useWorkplaceGroup(workplaceGroupId: string): UseWorkplaceGroupHook {
  const [state, dispatch] = useReducer(reducer, {
    item: null,
    isLoading: true,
  })

  const shouldReload = useShouldReload()

  useEffect(() => {
    api.workplaceGroup
      .details({
        workplaceGroupId,
      })
      .then((item) => {
        dispatch({
          type: Actions.DETAILS,
          item,
        })
      })
      .catch((error: ApolloError) => Toaster.fail({ error }))
  }, [workplaceGroupId, shouldReload.workplaceGroups])

  return {
    ...state,
    id: workplaceGroupId,
  }
}
